// ==========================================================
// File: src/pages/UserList.jsx (Stable SORTING Logic - ADMIN Removed)
// ==========================================================

import React from 'react';
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, Box, Divider, Typography, Badge } from '@mui/material'; 
 

const UserList = ({ users, selectedUserId, onSelectUser, unreadMessages = {} }) => {
    
    // 🧹 1. Filter out ADMIN users before anything else
    const filteredUsers = users.filter(user => user.group?.toUpperCase() !== "ADMIN");


    
    // 2. Attach original index for stable sorting
    const usersWithIndex = filteredUsers.map((user, index) => ({
        ...user,
        originalIndex: index
    }));

    // 3. Stable sort by unread messages (desc) then by original order
    // ✅ Ito ang nagpapapunta sa mga user na may bagong mensahe sa TOP ng listahan.
    const sortedUsers = usersWithIndex.sort((a, b) => {
        const unreadA = unreadMessages[a.userId] || 0;
        const unreadB = unreadMessages[b.userId] || 0;

        if (unreadA > unreadB) return -1; // Mas mataas na unread count, mas mauna
        if (unreadA < unreadB) return 1;
        return a.originalIndex - b.originalIndex; // Stable sort
    });

    return (
        <Box sx={{ 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column',
            // Nililimitahan ang taas para mag-scroll ang listahan sa loob
            maxHeight: { xs: '70vh', md: '100%' }, 
            overflow: 'hidden', 
            borderRight: '1px solid #e0e0e0'
        }}>
            
            
            <Box sx={{ 
                p: { xs: 1.5, md: 2 }, 
                bgcolor: '#0056D2', 
                borderBottom: '1px solid #003c94', 
                flexShrink: 0,
                zIndex: 1 // Para laging nasa taas habang nag-scroll ang listahan
            }}>
                <Typography 
                    variant="h6" 
                    fontWeight={600} 
                    sx={{ 
                        color: '#ffffff', 
                        fontSize: { xs: '1rem', md: '1.25rem' },
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <span>Online Clients</span>
                    <Box sx={{ bgcolor: 'rgba(255,255,255,0.2)', px: 1, borderRadius: 1, fontSize: '0.9rem' }}>
                        {sortedUsers.length}
                    </Box>
                </Typography>
            </Box>
            
            
            <List 
                disablePadding 
                sx={{ 
                    flexGrow: 1, 
                    overflowY: 'auto', 
                    bgcolor: '#fbfbfb',
                    // Smooth scrolling para sa mobile
                    WebkitOverflowScrolling: 'touch',
                    '&::-webkit-scrollbar': { width: '6px' },
                    '&::-webkit-scrollbar-thumb': { bgcolor: '#ccc', borderRadius: '10px' }
                }}
            >
                {sortedUsers.length === 0 ? (
                    <Box sx={{ p: 4, textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            No active support requests.
                        </Typography>
                    </Box>
                ) : (
                    sortedUsers.map((user) => { 
                        const unreadCount = unreadMessages[user.userId] || 0; 
                        const hasUnread = unreadCount > 0;
                        const isSelected = user.userId === selectedUserId;
        
                        return (
                            <React.Fragment key={user.userId}>
                                <ListItem
                                    button
                                    onClick={() => onSelectUser(user.userId)}
                                    selected={isSelected}
                                    sx={{ 
                                        m: 0,
                                        borderLeft: isSelected ? '4px solid #00C853' : '4px solid transparent',
                                        bgcolor: isSelected ? '#e0f2f1' : hasUnread ? '#fff3e0' : 'white', 
                                        py: { xs: 1, md: 1.2 }, // Mas compact na padding
                                        transition: '0.2s',
                                        '&:hover': {
                                            bgcolor: isSelected ? '#e0f2f1' : hasUnread ? '#ffe0b2' : '#f0f0f0',
                                        }
                                    }}
                                >
                                    <ListItemAvatar sx={{ minWidth: { xs: 45, md: 55 } }}> 
                                        <Badge 
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                            variant="dot"
                                            sx={{
                                                '& .MuiBadge-badge': {
                                                    bgcolor: '#00C853',
                                                    color: '#00C853',
                                                    boxShadow: '0 0 0 2px #fff',
                                                    width: 10,
                                                    height: 10,
                                                    borderRadius: '50%'
                                                }
                                            }}
                                        >
                                            <Avatar sx={{ 
                                                bgcolor: '#0056D2', 
                                                color: 'white',
                                                width: { xs: 32, md: 40 },
                                                height: { xs: 32, md: 40 },
                                                fontSize: '0.9rem'
                                            }}>
                                                {user.email?.charAt(0)?.toUpperCase() || '?'}
                                            </Avatar>
                                        </Badge>
                                    </ListItemAvatar>
                                    
                                    <ListItemText 
                                        primary={user.email?.split('@')[0] || 'Unknown User'}
                                        secondary={user.group}
                                        primaryTypographyProps={{ 
                                            fontWeight: hasUnread ? 700 : 500, 
                                            color: hasUnread ? '#002452' : '#333',
                                            noWrap: true, // Iwas "overflow" ng pangalan
                                            fontSize: { xs: '0.85rem', md: '0.95rem' }
                                        }}
                                        secondaryTypographyProps={{ 
                                            color: '#757575',
                                            fontSize: { xs: 10, md: 11 },
                                            noWrap: true
                                        }}
                                    />
                                    
                                    {hasUnread && (
                                        <Box sx={{ 
                                            bgcolor: '#FF5252',
                                            color: 'white',
                                            borderRadius: '12px',
                                            minWidth: 18, 
                                            px: 0.8, 
                                            height: 18,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 10,
                                            fontWeight: 'bold',
                                            ml: 1,
                                            boxShadow: '0 2px 4px rgba(255,82,82,0.3)'
                                        }}>
                                            {unreadCount} 
                                        </Box>
                                    )}
                                </ListItem>
                                <Divider variant="inset" component="li" sx={{ ml: 8, opacity: 0.6 }}/> 
                            </React.Fragment>
                        );
                    })
                )}
            </List>
        </Box>
    );
};

export default UserList;